import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductOneCallComponent } from '@boels/elements';
import { BoelsVariantOption } from '@boels/models';

@Component({
  selector: 'boels-product-variant-selector-list-item',
  templateUrl: 'product-variant-selector-list-item.component.html',
  styleUrls: ['product-variant-selector-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductOneCallComponent],
})
export class ProductVariantSelectorListItemComponent {
  @Input() variantOption: BoelsVariantOption;
}
